/*
 * Copyright (c) 2023. iSecNew10 Enterprises LLC
 */

import React, {useState} from 'react';
import './index.css'
import NavigationItemProps from '../../../../types/elements/NavigationItem';
import NavigationItem from './NavigationItem';
import Constants from '../../../../Constants';
import SocialIcons from './SocialIcons';
import BurgerMenuItem from './BurgerMenuItem';
import NavBarLogo from './NavBarLogo';
import {Link} from 'react-router-dom';
import Route from '../../../../types/Route';
import Routes from '../../../../Routes';

const NavBar = (props: {
    currentRoute: Route,
    width: number
}) => {
    const {currentRoute, width} = props;

    const [showMobileNav, setShowMobileNav] = useState(false);

    const renderNavItem = (navItem: NavigationItemProps, index: number) => {
        return (
            <NavigationItem
                active={navItem.route?.path === currentRoute.path}
                info={navItem} key={'nav_item_' + index}
                onClick={() => {
                    if (showMobileNav) {
                        setShowMobileNav(false)
                    }
                }}
            />
        )
    }

    return (
        <div id="navBar">
            <Link
                style={{
                    position: 'relative'
                }}
                to="/"
            >
                <NavBarLogo width={width}/>
            </Link>
            {width >= Constants.LayoutBreakpoints.desktop ? (
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start'
                }}>
                    <div id="navItems">
                        <ul>
                            {Routes.NavigationItems.map(renderNavItem)}
                        </ul>
                    </div>
                    <SocialIcons color={false}/>
                </div>
            ) : (
                <div id="mobileNavItems">
                    {width >= Constants.LayoutBreakpoints.tablet ? (
                        <SocialIcons color={false}/>
                    ) : null}
                    <BurgerMenuItem width={width} onClick={() => Constants.executeWithoutLoader(() => setShowMobileNav(true))}/>
                    {showMobileNav ? (
                        <div id="mobileNav">
                            <button
                                id="closeMobileNavButton"
                                onClick={() => Constants.executeWithoutLoader(() => setShowMobileNav(false))}
                            >
                                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20 2L2 20M2 2L20 20" stroke="#47C2D0" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </button>
                            <ul>
                                {Routes.NavigationItems.map(renderNavItem)}
                            </ul>
                            {width < Constants.LayoutBreakpoints.tablet ? (
                                <SocialIcons color={true}/>
                            ) : null}
                        </div>
                    ) : null}
                </div>
            )}
        </div>
    )
}

export default NavBar
